import React from 'react';

export const BRAVOS_LOGO_URL = '/Bravos_Logo.svg';
export const BRAVOS_ICON_URL = '/Bravos_Icon.svg';

type BravosWordmarkProps = {
  className?: string;
  /**
   * Kept so existing call sites compile. Colour follows the surrounding text
   * (`currentColor`). Do not invert the asset: a CSS filter rasterizes the SVG.
   */
  invertOnDark?: boolean;
  /** `icon` = geometric mark only; `full` = mark + word (default) */
  variant?: 'full' | 'icon';
};

export function BravosWordmark({
  className = 'h-6 w-auto',
  variant = 'full',
}: BravosWordmarkProps) {
  const isIcon = variant === 'icon';
  const src = isIcon ? BRAVOS_ICON_URL : BRAVOS_LOGO_URL;
  return (
    <span
      role="img"
      aria-label="Bravos"
      className={`inline-block shrink-0 bg-current align-middle ${className}`}
      style={{
        aspectRatio: isIcon ? '583 / 660' : '3043 / 660',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
      }}
    />
  );
}
